import loadableRetry from '@/utils/loadable-retry';
import loadable from '@loadable/component';
import { Mapper } from '@multitenancy-spa/components-manager/esm/services/components-manager/enum';
import type { MappingConfig } from '@multitenancy-spa/components-manager/esm/services/components-manager/typings';
import { EnvVarsService } from '@multitenancy-spa/env-vars-service/esm/services/env-vars-service';

const component = loadable(() =>
	loadableRetry(
		() =>
			import(
				'@/components/atomic/templates/navigation/chatapp-contactdetails/component'
			),
	),
);

const ChatAppContactDetails: MappingConfig = {
	resourceType: `${EnvVarsService.getVar('VITE_APP_ID')}/components/chatappcontactdetails`,
	mapper: Mapper.MAP_TO,
	component: component as any,
};

export default ChatAppContactDetails;
